'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
import { label3ClassName } from '../../typography/Label/Label3';
export type RadioLabelProps = Omit<Headless.LabelProps, 'as' | 'className'> & {
  className?: string;
};

/**
 * Label3-styled label wired into the surrounding Headless UI `Field`, so clicking
 * it toggles the `Radio` control it belongs to. Use inside `RadioField`.
 */
export function RadioLabel(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(label3ClassName, "cursor-pointer", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Headless.Label data-slot="label" {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}